import {
  DataGridProps,
  GridColDef,
  GridColumnVisibilityModel,
  GridFilterModel,
  GridPaginationModel,
  GridRenderCellParams,
  GridRowSelectionModel,
  GridRowsProp,
  GridSortItem,
  GridSortModel,
  GridTreeNodeWithRender,
  GridValidRowModel,
  DataGrid as MuiDataGrid,
} from "@mui/x-data-grid";
import { deDE } from "@mui/x-data-grid/locales";

type Props = DataGridProps;

export const DataGrid = ({ sx, ...props }: Props) => {
  return <MuiDataGrid localeText={deDE.components.MuiDataGrid.defaultProps.localeText} sx={{ ...(sx && { ...sx }) }} {...props} />;
};

export type {
  DataGridProps,
  GridColDef,
  GridColumnVisibilityModel,
  GridFilterModel,
  GridPaginationModel,
  GridRenderCellParams,
  GridRowSelectionModel,
  GridRowsProp,
  GridSortItem,
  GridSortModel,
  GridTreeNodeWithRender,
  GridValidRowModel,
};
